import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  margin-left: 15px;
  background: ${(props) => props.theme.colors?.greys.lightest || '#ffffff'};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
`;
